import React, { useRef } from "react";
import { useHistory } from "react-router-dom";
import Profile from "../Profile/profile";

interface AppTopbarProps {
  isLoggedIn: boolean;
  setOpenSignIn: (value: boolean) => void;
  setOpenSettings: (value: boolean) => void;
  homeLinkTo?: string;
  /** Swallows the Home link's click while a page-level operation is mid-flight (e.g. a batch
   * upload) that leaving would corrupt. Deliberately silent -- no disabled styling. */
  disableNavigation?: boolean;
}

const AppTopbar: React.FC<AppTopbarProps> = ({
  isLoggedIn,
  setOpenSignIn,
  setOpenSettings,
  homeLinkTo = "/home",
  disableNavigation,
}) => {
  const history = useHistory();
  const avatarAnchorRef = useRef<HTMLDivElement | null>(null);

  return (
    <div className="home-topbar">
      <span
        className="home-topbar__home-link"
        onClick={() => {
          if (disableNavigation) return;
          history.push(homeLinkTo);
        }}
      >
        Home
      </span>
      {isLoggedIn ? (
        <div
          className="home-topbar__avatar-wrap"
          onClick={(e) => {
            const avatarEl = avatarAnchorRef.current?.querySelector<HTMLElement>(
              ".profile-avatar-container"
            );
            if (!avatarEl || avatarEl.contains(e.target as Node)) return;
            avatarEl.click();
          }}
        >
          <div ref={avatarAnchorRef}>
            <Profile setOpenSettings={setOpenSettings} anchor={avatarAnchorRef} />
          </div>
          <span className="home-topbar__chevron">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M6 9l6 6 6-6" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
        </div>
      ) : (
        <button
          type="button"
          className="button_text d-flex justify-content-center align-items-center button_text_signin px-4 py-2"
          onClick={() => setOpenSignIn(true)}
        >
          Sign In
        </button>
      )}
    </div>
  );
};

export default AppTopbar;
